
export default class ResponsiveImage {

    static initAll() {
        return new ResponsiveImage();
    }

    constructor() {
        window.responsiveResizeObserver = new ResizeObserver((entries) => {
            entries.forEach(entry => {
                var imgWidth = entry.target.getBoundingClientRect().width;
                entry.target.parentNode.querySelectorAll('source').forEach((source) => {
                    source.sizes = Math.ceil(imgWidth / window.innerWidth * 100) + 'vw';
                });
            });
        });

        this.observe();

        Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
            succeed(({ snapshot, effect }) => {
                setTimeout(() => {
                    this.observe();
                }, 100);
            })
        })
    }

    observe() {
        document.querySelectorAll('[data-statamic-responsive-images]').forEach(responsiveImage => {
            responsiveResizeObserver.onload = null;
            responsiveResizeObserver.observe(responsiveImage);
        });
    }
}